import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { LogDeviceModel } from 'src/app/shared/models/log-device.model';
import { OccupationModel } from 'src/app/shared/models/occupation.model';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { CaptureService } from 'src/app/shared/services/capture/capture.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { BioCatchService } from 'src/app/shared/services/external/biocatch/biocatch.service';
import { FirmlyApprovedService } from 'src/app/shared/services/firmly-approved/firmly-approved.service';
import { ValidationHelperService } from 'src/app/shared/services/helpers/validation-helper.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { PostValidateService } from 'src/app/shared/services/post-validate/post-validate.service';
import { RequestService } from 'src/app/shared/services/request/request-onboarding.service';

import { BitacoraService } from '../../../shared/services/bitacora/bitacora.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { DaliService, IPageLoadModel } from '@dali/tagger-ng8';
import { PAGEVIEW as PAGEVIEW_FA,
  CHANNEL as CHANNEL_FA,
  COUNTRY as COUNTRY_FA,
  BUSINNESS as BUSINNESS_FA,
  ENVIRONMENT as ENVIRONMENT_FA,
  FAMILY as FAMILY_FA,
  SUBFAMILY as SUBFAMILY_FA,
  PRODUCT as PRODUCT_FA } from 'src/app/shared/constants/dali-fa-tc.constants';
import { EVENT as EVENT_FA_LD } from 'src/app/shared/constants/dali-fa-ld.constants';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';

@Component({
  selector: 'app-one-time-password',
  templateUrl: './one-time-password.component.html',
  styleUrls: ['./one-time-password.component.scss'],
})
export class OneTimePasswordComponent implements OnInit {
  cellphone: any = '';
  numberCode: any;
  otpFormControl: any;
  formGroup: FormGroup;
  basicData: any;
  selectedOccupation: OccupationModel;
  phone: string;
  client_id: string;
  alertModel: { message: string, type: string, icon?: string };
  intentos: number;
  products = {
    creditCard: 'tcr',
    payroll: 'cta_nom',
    savings: 'cta',
    revolvingCredit: 'crp',
    freeInvestment: 'ord',

  };
  devicePrint: LogDeviceModel;
  validations: number;

  incomesRequest: boolean;
  clientDataRequest: boolean;
  private clientDataRequestNext: string;
  incomesRequestNext: string;

  constructor(
    public copyService: CopyService,
    private headerService: HeaderService,
    private formBuilder: FormBuilder,
    private abreCuentasService: AbreCuentasService,
    private navigationService: NavigationService,
    private captureService: CaptureService,
    private bioCatchService: BioCatchService,
    public validationHelperService: ValidationHelperService,
    private requestService: RequestService,
    private bitacoraService: BitacoraService,
    private parametersService: ParametersService,
    private postvalidate: PostValidateService,
    private firmlyApprovedService: FirmlyApprovedService,
    private channelCommunicatorService: ChannelCommunicatorService,
    private daliService: DaliService,
    private taggingServices: TaggingService,
  ) {
    this.headerService.show(true, true, true);
    this.intentos = this.abreCuentasService.getIntentoOtp();
    this.devicePrint = new LogDeviceModel();
    this.validations = this.abreCuentasService.getValidationOtp();
    this.formGroup = this.formBuilder.group({});
  }

  ngOnInit(): void {
    this.sendTagging('init');
    if (this.taggingServices.isFirmlyAprovedMono()) {
      this.sendOTPPageLoad();
    }
    this.formGroup = new FormGroup({
      otpFormControl: new FormControl('', [
        Validators.minLength(6),
        Validators.maxLength(6),
        Validators.required,
      ]),
    });
    let nextCode: string;
    if (this.abreCuentasService.getUserJemelii()) {
      console.log('///** ' + this.abreCuentasService.getContactInfo().mobile_number);
      const contactInfo = this.abreCuentasService.getContactInfo();
      this.phone = contactInfo.mobile_number;
      this.client_id = this.abreCuentasService.getRescueData().number_id + '_1';
      nextCode = '200';
      this.clientDataRequest = true;
      this.clientDataRequestNext = nextCode;
      if (this.phone === '') {
        this.abreCuentasService.caseInfoError('512');
        this.navigationService.nextStep('301');
        return;
      }
    } else {
      this.basicData = this.abreCuentasService.getCustomerData().basic;
      if (this.abreCuentasService.getproductSelected().product_type === BUSINESS_CONST.PRODUCT_TYPE_PAYROLL) {
        const occupation = this.parametersService.getSetting(OpEnum.OCCUPATIONS_LIST)[0];
        this.abreCuentasService.setOccupationSelected(occupation);
        this.selectedOccupation = occupation;

        const nowDate = new Date();
        const lastUpdateDate = new Date();
        lastUpdateDate.setTime(this.basicData.last_update_date);
        const configClient = this.parametersService.getSetting(OpEnum.CONFIG_CLIENT_EXIST);
        lastUpdateDate.setDate(lastUpdateDate.getDate() + configClient.days_update);
        nextCode = lastUpdateDate.getTime() < nowDate.getTime() ? '106' : '107';
        nextCode = this.getValueOfNextCode(nextCode);
      } else {
        nextCode = '200';
      }
      this.clientDataRequest = true;
      this.clientDataRequestNext = nextCode;

      this.client_id = this.basicData.document.number + '_' + this.basicData.document.type;
      this.phone = this.basicData.phones.find((x: any) => x.phone_type === 'Mobile').phone_number;
      if (this.phone === '') {
        this.abreCuentasService.caseInfoError('512');
        this.navigationService.nextStep('301');
        return;
      }

    }
    this.generateCode();
  }

  getValueOfNextCode(nextCode: string) {
    return (
      (
        !this.validationHelperService.isValidExistingClient() ||
        this.abreCuentasService.getOccupationSelected().name !== this.basicData.profession
      ) &&
      this.abreCuentasService.getproductSelected().product_type === BUSINESS_CONST.PRODUCT_TYPE_PAYROLL
    ) ? '106' : nextCode;
  }

  async validateOtpCode() {
    this.sendTagging('next', 'bottom', '2');
    if (this.taggingServices.isFirmlyAprovedMono()) {
      this.sendValidateButtonEvent();
    }
    this.validations++;
    this.abreCuentasService.setIntentoOtp(this.validations);
    if (this.blockOtp(this.validations, 4) || this.blockOtp(this.intentos)) { return; }

    const device = this.abreCuentasService.getDeviceInfo();
    const body = {
      data: {
        client_id: this.client_id,
        authorization_code: this.numberCode,
        divice_print: device.device_id,
        device_cookie: '',
      },
    };
    await this.captureService.validateOTP(body).then(
      (res: any) => {
        try {
          if (res.body) {
            this.next();
          } else if (res.code) {
            let code = res.code;
            code = String(code).split('|')[2];
            switch (code) {
              case '3':
                this.alertModel = { message: 'El código que ingresaste es incorrecto.', type: 'error', icon: '' };
                break;
              case '6':
              case '10':
                this.alertModel = { message: 'El código de confirmación ha expirado. Reenvia el código.', type: 'error', icon: '' };
                break;
              default:
                this.navigationService.navigateToGeneralInformation('500');
            }
          } else {
            this.navigationService.navigateToGeneralInformation('500');
          }
        } catch (e) {
          console.log(e);
        }

      }).catch(() => this.navigationService.navigateToGeneralInformation('500'));
  }

  reactiveInputChangeCode(e: any) {
    let value = String(e.item.value);
    value = value.replace(/\D/g, '');
    e.$event.target.value = value;
    this.numberCode = value;
    /* this.otpFormControl.setValue(value); */
    const controlIncomes = this.formGroup.controls['otpFormControl'] as FormControl;
    controlIncomes.setValue(value);
  }

  resendConfirmationCode() {
    this.sendTagging('resend', 'bottom', '3');
    if (this.taggingServices.isFirmlyAprovedMono()) {
      this.sendResendOTPButtonEvent();
    }
    try {
      this.intentos++;
      this.abreCuentasService.setIntentoOtp(this.intentos);
      if (this.blockOtp(this.intentos)) { return; }

      const selectedProduct = this.abreCuentasService.getproductSelected();
      const eventName = 'resend_otp_' + this.products[selectedProduct.product_type];
      this.sendBitacora(eventName);
    } catch (error) {
      console.log();
    }

    this.generateCode(true);
  }

  gotoProblems() {
    this.sendTagging('problems', 'bottom', '4');
    if (this.taggingServices.isFirmlyAprovedMono()) {
      this.sendHaveProblemsButtonEvent();
    }
    this.navigationService.nextStep('301');
  }

  async next() {
    const selectedProduct = this.abreCuentasService.getproductSelected();
    try {
      const event = 'identification_otp_' + this.products[selectedProduct.product_type];
      this.sendBitacora(event);
    } catch (error) {
      console.log();
    }

    if (selectedProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_PAYROLL) {
      this.postvalidate.solicitationId();
      if (this.firmlyApprovedService.isEmpty()) {
        await this.callIncomes();
      }
    } else {
      this.incomesRequest = true;
      this.incomesRequestNext = '000';
    }
    this.advance();
  }

  private async generateCode(showAlert: boolean = false) {
    const device = this.abreCuentasService.getDeviceInfo();
    const contact = this.abreCuentasService.getUserJemelii() ? this.abreCuentasService.getContactInfo()
    : this.abreCuentasService.getCustomerData().contact;
    const body = {
      data: {
        client_id: this.client_id,
        email: contact.email,
        phone: {
          phone_number: this.phone,
        },
        divice_print: device.device_id,
        device_cookie: '',
        trn_code: '5',
      },
    };
    await this.captureService.getOTP(body).then(
      (res: any) => {
        try {
          if (res.data.message === 'procesado.') {
            if (!showAlert) { return; }
            this.alertModel = { message: 'Código reenviado', type: 'success', icon: 'check' };
          } else if (res.data) {
            let code = res.data.mensagem.code;
            code = String(code).split('|')[2];
            if (code === '1010016') {
              this.alertModel = { message: 'Has llegado al número de intentos permitidos, intenta mañana.', type: 'error', icon: '' };
              this.navigationService.pageLoadTag('alertModel', ['pv428', '', '', '']);
            } else {
              this.navigationService.navigateToGeneralInformation('500');
            }
          }
        } catch (e) {
          console.log(e);
        }
      }).catch(error => console.log(error));
  }

  async callIncomes() {
    await this.captureService.sendProspectOccupation().then(
      (res: any) => {
        console.log('callIncomes >>> Linea 255 >>> ', res);
        let nextCode = '';
        if (res) {
          this.abreCuentasService.setinfoInferredIncomes(res.body.data);
          if (!res.status || res.status === 500) {
            nextCode = '500';
          } else if (res.status !== 200) {
            const codigo = res.body.data.codigo;
            switch (codigo) {
              case '422-06':
                nextCode = '106';
                break;
              case '422-07':
                nextCode = '106';
                break;
              case '400':
                nextCode = '500';
                break;
            }
          } else if (res.body.data.income_amount.amount === 0) {
            nextCode = '106';
          } else {
            nextCode = '000';
          }
        } else {
          nextCode = '500';
        }
        this.incomesRequest = true;
        this.incomesRequestNext = nextCode;
      },
    ).catch(() => this.navigationService.navigateToGeneralInformation('500'));
  }

  private blockOtp(intentos: number, validate = 4): boolean {
    const flag = intentos >= validate;
    if (flag) {
      if (intentos > validate) {
        this.navigationService.nextStep('201');
      }
      this.alertModel = { message: 'Has llegado al número de intentos permitidos, intenta mañana.', type: 'error', icon: '' };
    }
    return flag;
  }

  private sendBitacora(eventName: string) {
    this.bitacoraService.saveDataInBitacora(eventName);
  }

  private advance() {
    console.log('One-Time >>>>> ClientDataRequest >>> ', this.clientDataRequest, '\n IncomesRequest >>>> ', this.incomesRequest);
    if (this.clientDataRequest && this.incomesRequest) {
      if (this.abreCuentasService.getUserJemelii()) {
        this.navigationService.nextStep('200');
      } else if (!this.validationHelperService.validateMailPhone() &&
        this.abreCuentasService.getproductSelected().product_type === BUSINESS_CONST.PRODUCT_TYPE_PAYROLL) {
        this.navigationService.navigateToGeneralInformation('512');
      } else if (this.incomesRequestNext === '000') {
        this.navigationService.nextStep(this.clientDataRequestNext);
      } else {
        this.navigationService.navigateToGeneralInformation(this.incomesRequestNext);
      }

    } else if (this.abreCuentasService.getproductSelected().product_type === 'creditCard' && this.clientDataRequest) {
      this.navigationService.nextStep(this.clientDataRequestNext);
    }
  }

  /* ------------- Taggeo ------------- */

  /* ------------ Taggeo - PageLoad ------------ */
  sendOTPPageLoad(): void {
    const isApp = this.channelCommunicatorService.getChannelId() === '141';
    const changes: IPageLoadModel[] = [
      {
        path: PAGEVIEW_FA.pv2pageName.path,
        value: `${isApp ? CHANNEL_FA.superapp : CHANNEL_FA.homeBanking}:${COUNTRY_FA.co}:${BUSINNESS_FA.pf}:${ENVIRONMENT_FA.loggeado}:${FAMILY_FA.services}:${SUBFAMILY_FA.request}:${PRODUCT_FA.request}:${PAGEVIEW_FA.pv2pageName.value}`,
      },
      {
        path: PAGEVIEW_FA.pv2pageFamily.path,
        value: PAGEVIEW_FA.pv2pageFamily.value,
      },
      {
        path: PAGEVIEW_FA.pv2subFamily.path,
        value: PAGEVIEW_FA.pv2subFamily.value,
      },
      {
        path: PAGEVIEW_FA.pv2pageAction.path,
        value: PAGEVIEW_FA.pv2pageAction.value,
      },
      {
        path: PAGEVIEW_FA.pv2pageid.path,
        value: OneTimePasswordComponent.name,
      },
      {
        path: PAGEVIEW_FA.pv2transactionName.path,
        value: `${PAGEVIEW_FA.pv2transactionName.value.slice(0, -2)}${this.taggingServices.getProductFlow()}`,
      },
      {
        path: PAGEVIEW_FA.pv2transactionTransactionStep.path,
        value: PAGEVIEW_FA.pv2transactionTransactionStep.value,
      },
    ];
    this.taggingServices.addCommonPageChanges(changes);
    this.daliService.pageLoad(changes);
  }

  /* ------------ Taggeo - Events ------------ */

  sendBackButtonEvent(): void {
    this.sendTagging('prev', 'top', '1');
    if (!this.taggingServices.isFirmlyAprovedMono()) {
      return;
    }
    const data = [
      {
        path: EVENT_FA_LD.pv2E1setData.pv2E1transactionTransactionStep.path,
        value: EVENT_FA_LD.pv2E1setData.pv2E1transactionTransactionStep.value,
      },
      {
        path: EVENT_FA_LD.pv2E1setData.pv2E1transactionName.path,
        value: `${EVENT_FA_LD.pv2E1setData.pv2E1transactionName.value.slice(0, -2)}${this.taggingServices.getProductFlow()}`, // cambiar valor segun sea LD o TC
      },
    ];
    const event = {
      category: {
        module: EVENT_FA_LD.customCategory.module.body,
        type: EVENT_FA_LD.customCategory.type.button,
        position: EVENT_FA_LD.customCategory.position.bottom,
      },
      action: EVENT_FA_LD.customAction.click,
      label: EVENT_FA_LD.pv2E1customLabel,
    };
    this.daliService.trackEvent(event, data);
  }

  sendValidateButtonEvent(): void {
    const data = [
      {
        path: EVENT_FA_LD.pv2E2setData.pv2E2transactionTransactionStep.path,
        value: EVENT_FA_LD.pv2E2setData.pv2E2transactionTransactionStep.value,
      },
      {
        path: EVENT_FA_LD.pv2E2setData.pv2E2transactionName.path,
        value: `${EVENT_FA_LD.pv2E2setData.pv2E2transactionName.value.slice(0, -2)}${this.taggingServices.getProductFlow()}`, // cambiar valor segun sea LD o TC
      },
    ];
    const event = {
      category: {
        module: EVENT_FA_LD.customCategory.module.body,
        type: EVENT_FA_LD.customCategory.type.button,
        position: EVENT_FA_LD.customCategory.position.bottom,
      },
      action: EVENT_FA_LD.customAction.click,
      label: EVENT_FA_LD.pv2E2customLabel,
    };
    this.daliService.trackEvent(event, data);
  }

  sendResendOTPButtonEvent(): void {
    const data = [
      {
        path: EVENT_FA_LD.pv2E3setData.pv2E3transactionTransactionStep.path,
        value: EVENT_FA_LD.pv2E3setData.pv2E3transactionTransactionStep.value,
      },
      {
        path: EVENT_FA_LD.pv2E3setData.pv2E3transactionName.path,
        value: `${EVENT_FA_LD.pv2E3setData.pv2E3transactionName.value.slice(0, -2)}${this.taggingServices.getProductFlow()}`, // cambiar valor segun sea LD o TC
      },
    ];
    const event = {
      category: {
        module: EVENT_FA_LD.customCategory.module.body,
        type: EVENT_FA_LD.customCategory.type.button,
        position: EVENT_FA_LD.customCategory.position.bottom,
      },
      action: EVENT_FA_LD.customAction.click,
      label: EVENT_FA_LD.pv2E3customLabel,
    };
    this.daliService.trackEvent(event, data);
  }

  sendHaveProblemsButtonEvent(): void {
    const data = [
      {
        path: EVENT_FA_LD.pv2E4setData.pv2E4transactionTransactionStep.path,
        value: EVENT_FA_LD.pv2E4setData.pv2E4transactionTransactionStep.value,
      },
      {
        path: EVENT_FA_LD.pv2E4setData.pv2E4transactionName.path,
        value: `${EVENT_FA_LD.pv2E4setData.pv2E4transactionName.value.slice(0, -2)}${this.taggingServices.getProductFlow()}`, // cambiar valor segun sea LD o TC
      },
    ];
    const event = {
      category: {
        module: EVENT_FA_LD.customCategory.module.body,
        type: EVENT_FA_LD.customCategory.type.button,
        position: EVENT_FA_LD.customCategory.position.bottom,
      },
      action: EVENT_FA_LD.customAction.click,
      label: EVENT_FA_LD.pv2E4customLabel,
    };
    this.daliService.trackEvent(event, data);
  }

  sendTagging(value: any, position?: string, event?: string) {
    const page = '3';
    const extras = {
      pageValue: 'OneTimePassword',
    };
    this.taggingServices.sendTaggValues(value, page, position, event, extras);
  }
}
